import React, {Component} from 'react';
import {ChannelLogo} from "../channels/ChannelLogo";

class AdAccountReadOnlyInput extends Component {
    render() {
        return (
            <div className={"form-control ad-account read-only"}>
                <span className="logo">
                    <ChannelLogo useOld={false} width="20px" height={"20px"} vspace={0} hspace={5}
                                 channel={this.props.channel} marginLeft={"5px"} />
                </span>
                <span>
                    {this.props.adAccountName} ({this.props.adAccountId})
                </span>
            </div>
        );
    }
}

export default AdAccountReadOnlyInput;
